import React, { useMemo } from "react"
import _ from "lodash"

import "./Icon.scss"
import "@Quiz/helper"

// export const IconHappy: React.FC<{iconIds: string[]}> = ({ iconIds }) => {
//   const indexInIdsUsedWithModulo = useMemo(() => _.random(0, 9999), [])  
// 
//   const className = [
//     "neo__icon",
//     `neo__icon--${iconIds[indexInIdsUsedWithModulo % iconIds.length]}`
//   ].join(" ")
//   return <div className={className} />
// }

export const Icon: React.FC<{iconIds: string[]}> = ({ iconIds }) => {
  const indexInIdsUsedWithModulo = useMemo(() => _.random(0, 9999), [])  

  return <div className="neo__icon" style={{backgroundImage: `var(--quiz__icon__${iconIds[indexInIdsUsedWithModulo % iconIds.length]})`}}/>
}

// export const IconSad: React.FC<{iconIds: string[]}> = ({ iconIds }) => {
//   const indexInIdsUsedWithModulo = useMemo(() => _.random(0, 9999), [])
// 
//   const className = [
//     "neo__icon",
//     `neo__icon--${iconIds[indexInIdsUsedWithModulo % iconIds.length]}`
//   ].join(" ")
//   return <div className={className} />
// }
// 
// export const IconSoso: React.FC<{iconIds: string[]}> = ({ iconIds }) => {
//   const indexInIdsUsedWithModulo = useMemo(() => _.random(0, 9999), [])
// 
//   const className = [
//     "neo__icon",
//     `neo__icon--${iconIds[indexInIdsUsedWithModulo % iconIds.length]}`
//   ].join(" ")
//   return <div className={className} />
// }

// export const IconCheck: React.FC = () => {
//   const className = [
//     "neo__icon",
//     "neo__icon--check"
//   ].join(" ")
//   return <div className={className} />
// }

type ShareType = "whatsapp" | "facebook" | "mail" | "twitter"

export const IconShare: React.FC<{shareType: ShareType}> = ({ shareType }) => {
  const className = [
    "neo__icon",
    "neo__icon--share",
    `neo__icon--${shareType}`
  ].join(" ")
  return <div className={className} />
}
